import { render, staticRenderFns } from "./AddTopes.vue?vue&type=template&id=0cdc6f42&scoped=true"
import script from "./AddTopes.vue?vue&type=script&lang=js"
export * from "./AddTopes.vue?vue&type=script&lang=js"
import style0 from "./AddTopes.vue?vue&type=style&index=0&id=0cdc6f42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc6f42",
  null
  
)

export default component.exports